/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bmr_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BMR & TDEE Calculator`)
};

const es_bmr_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de TMB y GEDT`)
};

const de_bmr_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grundumsatz- & Gesamtumsatz-Rechner (BMR & TDEE)`)
};

const nl_bmr_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BMR & TDEE Calculator`)
};

const fr_bmr_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur BMR & TDEE`)
};

const it_bmr_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore BMR e TDEE`)
};

const pt_br2_bmr_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de TMB e GET`)
};

const pt_bmr_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de TMB & TDEE`)
};

const ja_bmr_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基礎代謝・TDEE計算機`)
};

const zh_bmr_tool_name = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基础代谢率与每日总消耗计算器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bmr_tool_name = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bmr_tool_name(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bmr_tool_name", locale)
	if (locale === "en") return en_bmr_tool_name(inputs)
	if (locale === "es") return es_bmr_tool_name(inputs)
	if (locale === "de") return de_bmr_tool_name(inputs)
	if (locale === "nl") return nl_bmr_tool_name(inputs)
	if (locale === "fr") return fr_bmr_tool_name(inputs)
	if (locale === "it") return it_bmr_tool_name(inputs)
	if (locale === "pt-BR") return pt_br2_bmr_tool_name(inputs)
	if (locale === "pt") return pt_bmr_tool_name(inputs)
	if (locale === "ja") return ja_bmr_tool_name(inputs)
	return zh_bmr_tool_name(inputs)
};